module.exports = __webpack_public_path__ + "static/media/3.7.a4698c58.png";